/**
 * Adds a watch function to a class that observes property changes
 * @param {object} target - The class instance
 * @param {string} propName - Name of the property to watch
 * @param {string} handlerName - Name of the method to call when property changes
 * @param {object} options - Watch options
 * @param {boolean} options.waitUntilFirstUpdate - Whether to wait for first update before watching
 */
export function watch(target, propName, handlerName, options = {}) {
  const originalWillUpdate = target.willUpdate;

  const watchOptions = {
    waitUntilFirstUpdate: false,
    ...options
  };

  target.willUpdate = function (changedProps) {
    if (originalWillUpdate) {
      originalWillUpdate.call(this, changedProps);
    }

    if (changedProps.has(propName)) {
      const oldValue = changedProps.get(propName);
      const newValue = this[propName];

      if (oldValue !== newValue) {
        if (!watchOptions.waitUntilFirstUpdate || this.hasUpdated) {
          if (typeof this[handlerName] === 'function') {
            this[handlerName].call(this, oldValue, newValue);
          }
        }
      }
    }
  };
}

export function watchAll(instance, watchConfigs) {
  if (!Array.isArray(watchConfigs)) {
    console.warn('watchAll expects an array of watch configurations');
    return;
  }

  watchConfigs.forEach(({ propName, handlerName, options }) => {
    if (!propName || !handlerName) {
      console.warn('Each watch config must have propName and handlerName');
      return;
    }
    watch(instance, propName, handlerName, options);
  });
}